import { render } from "./RegenerateButton.vue?vue&type=template&id=536dc81e"
import script from "./RegenerateButton.vue?vue&type=script&lang=js"
export * from "./RegenerateButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/playbooks/RegenerateButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "536dc81e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('536dc81e', __exports__)) {
    api.reload('536dc81e', __exports__)
  }
  
  module.hot.accept("./RegenerateButton.vue?vue&type=template&id=536dc81e", () => {
    api.rerender('536dc81e', render)
  })

}


export default __exports__